var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.44255 23.3491L13.4545 20.4089V12.006L8.44255 14.9462V23.3491Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.138298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10788 15.2504L8.44256 15.4413V23.3492L8.10788 23.186V15.2504Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.138298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2455 22.6494L18.9366 19.9221V14.5921L14.2455 17.3194V22.6494Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.138298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6581 18.0745V17.3H14.2455V17.8311L18.967 20.5583L23.6581 17.8311",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6581 18.0745V17.3H14.2455V17.8311L18.967 20.5583L23.6581 17.8311",
    stroke: "black",
    strokeWidth: 0.138298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.967 25.8883L23.6581 23.1611V17.8311L18.967 20.5583V25.8883Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.138298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6581 17.3L18.9366 14.5728L14.2455 17.3L18.967 20.0272L23.6581 17.3Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.138298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6915 9.73788C21.4067 9.48538 21.094 9.26636 20.7594 9.08511C20.3636 8.84121 19.9045 8.71995 19.44 8.7366C19.0703 8.48764 18.6444 8.3346 18.2008 8.29128C17.8606 8.25256 17.1111 7.30107 16.9921 6.99128C16.7957 6.47682 16.1623 4.39682 16.2121 4.61533L15.4294 4.77022C15.4439 5.77359 15.6368 6.76637 15.9991 7.70213V7.70213C16.4044 8.7301 17.0057 9.66951 17.7694 10.4681C17.7341 11.0248 17.7788 11.5837 17.9021 12.1277C18.0736 13.234 17.9021 13.9753 17.9713 14.4677C14.0132 16.4038 13.1281 17.5462 13.5679 23.0034L14.6217 23.5898C15.1306 19.3192 15.103 18.8185 17.7362 17.383C16.4002 19.1034 16.5745 21.2 16.5164 24.7432L17.5702 25.3268C18.4581 20.5777 18.2589 20.0272 19.6613 18.7881C20.6294 17.9279 21.7689 17.8145 21.6528 16.5255C21.6589 16.2134 21.6459 15.9012 21.614 15.5906C22.0898 14.9987 22.5738 14.2077 22.5877 13.5023C22.6208 11.3587 22.3636 10.3215 21.6915 9.73788Z",
    fill: "#252525",
    stroke: "black",
    strokeWidth: 0.207447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5679 22.9896C10.9845 24.3172 12.6717 24.9257 14.6217 23.5759L13.5679 22.9896Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.207447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5164 24.7432C14.8209 25.5232 14.9813 27.1662 17.5702 25.3268L16.5164 24.7432Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.207447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1894 17.7536V17.0455L8.10788 14.7636V15.2504L17.1775 20.4698L22.1894 17.5323",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1894 17.7536V17.0455L8.10788 14.7636V15.2504L17.1775 20.4698L22.1894 17.5323",
    stroke: "black",
    strokeWidth: 0.138298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1774 28.8728L22.1894 25.9353V17.5323L17.1774 20.4698V28.8728Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.138298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1894 17.0455L13.1226 11.8262L8.10788 14.7636L17.1775 19.9857L22.1894 17.0455Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.138298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1775 28.8728L16.8455 28.7068V20.3038L17.1775 20.4698V28.8728Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.138298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2685 16.1853L15.7751 18.2349L13.3909 16.8657L16.887 14.8162L19.2685 16.1853Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.138298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3311 14.5755L12.8349 16.6251L10.4534 15.256L13.9496 13.2064L16.3311 14.5755Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.138298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8217 16.0332C18.5438 17.0151 19.3377 17.8919 20.704 16.567L19.8217 16.0332Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.207447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2121 4.60978C16.5274 2.4717 15.1362 3.11063 15.4294 4.76468L16.2121 4.60978Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.207447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8232 6.88618C18.5466 6.15043 18.7623 6.19746 18.8951 5.83788C18.8951 5.83788 18.5466 5.3732 19.9489 5.3649C19.9489 5.3649 19.8936 4.75639 21.0553 5.80746L20.5021 6.27767L19.1192 6.35788L18.8232 6.88618Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.207447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1468 9.06022C19.1371 9.18367 19.1204 9.30649 19.097 9.42809C19.0445 9.78767 20.3362 10.056 20.4966 9.26213C20.657 8.4683 20.7428 8.77256 21.0498 8.33277C21.4675 7.71596 21.426 6.6732 20.7372 6.36064C20.0485 6.04809 19.3128 6.0149 19.0251 6.30533C19.0002 6.33022 18.79 7.0383 18.5521 7.76022C18.4996 7.88402 18.4734 8.01742 18.4752 8.15191C18.477 8.28639 18.5069 8.41902 18.5629 8.54133C18.6188 8.66364 18.6996 8.77295 18.8002 8.86229C18.9007 8.95163 19.0188 9.01904 19.1468 9.06022V9.06022Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.207447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8632 6.54043C19.8689 6.59427 19.8874 6.64599 19.9169 6.69134C19.9465 6.7367 19.9864 6.77441 20.0333 6.8014C20.0803 6.82838 20.133 6.84386 20.187 6.84657C20.2411 6.84929 20.2951 6.83917 20.3445 6.81703C20.2718 7.05802 20.2836 7.31657 20.3777 7.55001C20.48 7.77958 20.6543 7.24852 20.6543 7.24852C20.6543 7.24852 20.4855 8.6315 20.6543 8.00915C20.8755 7.16277 21.2075 7.36745 21.2075 7.65511C21.2406 8.36873 20.563 8.67298 20.5796 8.98001C20.5989 9.34511 20.8064 8.82788 21 8.6315C21.2489 8.37426 21.3983 8.43788 21.5809 7.86256C21.8575 6.96362 21.4702 6.33022 21.3402 6.25554C21.2102 6.18086 21.4426 5.97894 20.8811 5.70235C20.3196 5.42575 19.5645 5.25979 19.7913 5.46447C19.7913 5.46447 18.5051 6.07298 18.9366 5.99001C18.9366 5.99001 18.7955 6.71192 19.8632 6.0315C19.8632 6.0315 19.4926 6.58469 19.8632 6.55703V6.54043Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.207447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5877 13.5106C22.5628 14.9268 20.704 16.5753 20.704 16.5753L19.8217 16.0415C19.8217 16.0415 21.4508 14.2381 21.2047 13.4747C21.0636 13.0404 20.8479 12.6449 20.7096 12.1996",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5877 13.5106C22.5628 14.9268 20.704 16.5753 20.704 16.5753L19.8217 16.0415C19.8217 16.0415 21.4508 14.2381 21.2047 13.4747C21.0636 13.0404 20.8479 12.6449 20.7096 12.1996",
    stroke: "black",
    strokeWidth: 0.207447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7694 10.446C17.7906 10.1501 17.8378 9.85672 17.9104 9.56915Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7694 10.446C17.7906 10.1501 17.8378 9.85672 17.9104 9.56915",
    stroke: "black",
    strokeWidth: 0.207447,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.766,
    height: 26,
    fill: "white",
    transform: "translate(8 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelPeople);
export default __webpack_public_path__ + "static/media/SelPeople.623254ed94009e282a7d4a84f327cb7f.svg";
export { ForwardRef as ReactComponent };